import { Button, Modal, Tooltip } from "antd";
import { MapContainer, Marker, TileLayer, useMap } from "react-leaflet";
import { FullscreenControl } from "react-leaflet-fullscreen";
import { useContext, useMemo, useRef, useState } from "react";
import Control from "react-leaflet-custom-control";
import Search from "antd/es/input/Search";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import { NotificationInfo, UserInfo } from "../../../context";

const EditLocation = ({ open, close, data, getMyMerchantInfo }) => {
  const mapRef = useRef();
  const [center, setcenter] = useState({ lat: 12.8797, lng: 121.774 });
  const [zoom, setzoom] = useState(5);
  const markerRef = useRef();
  const [allow, setAllow] = useState(false);
  const [displayBtn, setDisplayBtn] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const ComponentResize = () => {
    const map = useMap();
    setTimeout(() => {
      map.invalidateSize();
    }, 0);

    return null;
  };

  const ComponentCoordinates = ({ center, zoom }) => {
    const map = useMap();
    setTimeout(() => {
      map.setView(center, zoom);
      if (center.lat !== 12.8797) {
        setAllow(true);
      }
    }, 0);

    return null;
  };
  const onSearch = (value) => {
    axios
      .get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${value}.json?access_token=pk.eyJ1IjoiZGVueDcyIiwiYSI6ImNqYzIwZnl5eDBjaHAycW9kZ2doZW1laTMifQ.A4FqSmhMUdx624cwM4fjvw`
      )
      .then((res) => {
        setcenter({
          ...center,
          lat: res.data.features[0].geometry.coordinates[1],
          lng: res.data.features[0].geometry.coordinates[0],
        });
        setzoom(13);
        setAllow(true);
        setDisplayBtn(false);
      });
  };

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          // console.log("marker.getLatLng()", marker.getLatLng());
          setcenter(marker.getLatLng());
          setDisplayBtn(true);
        }
      },
    }),
    []
  );

  const handleUpdateMyLocation = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("latitude", center.lat);
    formdata.append("longitude", center.lng);

    axios
      .post("user/merchant/update-location", formdata)
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data);
        if (data === "success") {
          rerunNotif("success", "Updated location successfully.");
          setTimeout(() => {
            getMyMerchantInfo();
            close();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={() => close()}
        centered
        footer={null}
        closable={false}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  close();
                }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>

        <MapContainer
          center={center}
          zoom={zoom}
          scrollWheelZoom={true}
          style={{ width: "100%", height: "calc(50vh - 4rem)" }}
          ref={mapRef}
        >
          <ComponentResize />

          {data.latitude !== null ? (
            <ComponentCoordinates
              center={{ lat: data.latitude, lng: data.longitude }}
              zoom={13}
            />
          ) : (
            <ComponentCoordinates center={center} zoom={zoom} />
          )}

          <TileLayer
            url="https://api.mapbox.com/styles/v1/infimaxhp888/ckotweguz1lll18lnugoq4g6j/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiaW5maW1heGhwODg4IiwiYSI6ImNqeXZjOHNpazA5aW4zZHBvdDBhd3NiOWQifQ._czEMv00RYK5VQHXR0Sk2w"
            attribution=""
          />
          <FullscreenControl />
          <Marker
            position={
              data.latitude !== null
                ? displayBtn
                  ? center
                  : [data.latitude, data.longitude]
                : center
            }
            draggable={allow}
            // eventHandlers={() => handleEditDragMarker()}
            eventHandlers={eventHandlers}
            ref={markerRef}
          />
          <Control prepend position="topright">
            <div>
              <Search
                placeholder="Search places..."
                allowClear
                onSearch={onSearch}
                style={{
                  width: 200,
                }}
              />
            </div>
          </Control>
        </MapContainer>

        {displayBtn && (
          <Button
            style={{ marginTop: 10, width: "100%" }}
            onClick={handleUpdateMyLocation}
          >
            Update Location
          </Button>
        )}
      </Modal>
    </>
  );
};

export default EditLocation;
